<template>
 <div :class="divClass">
        <a :href="`${product.url}?categoryDisplayPrice=${displayPriceId}`">
            <img v-if="product.is_black_friday" :class="`${getExpressItemClass()} doorbuster`" src="/themes/rentone/assets/images/black-friday-badge.png">
            <img v-else-if="product.is_holiday_deal" class="express-delivery-cart doorbuster" src="/themes/rentone/assets/images/holiday-deals-sticker.png">
            <img v-else-if="product.is_express_delivery" :class="getExpressItemClass()" src="/themes/rentone/assets/images/express-delivery.svg">
            <img :src="product.images['255x255'][0]" :alt="product.name">
        </a>

        <p class="prodname"><a :href="`${product.url}?categoryDisplayPrice=${displayPriceId}`" v-html="displayProductName()"></a></p>
        <div v-html="displayPrice()"></div>
        <div class="row prodcart">
            <quick-add-to-cart :product-slug="product.slug" :options="product.options.multiple"></quick-add-to-cart>
            <div class="col-md-6 p-0 save" v-if="savings > 0"><h4>SAVE ${{ savings }}</h4>
                <p>the first week</p>
            </div>
        </div>
    </div>
</template>

<script>

    import QuickAddToCart from '../ecommerce/cart/QuickAddToCart.vue';

    export default {
        props: ['product', 'divClass', 'categoryDisplayPrice', 'globalPriceSetting', 'forceGlobalPriceSetting', 'expressItemClass'],
        components: {QuickAddToCart},
        data: () => ({
          displayPriceId: 0,
        }),
        methods: {
            getWeeklyPrice() {
                const weeklyPrice = _.filter(this.product.pricing, (price) => price.label === 'Weeks').pop();
                if (weeklyPrice !== undefined) {
                    return weeklyPrice.amount;
                }

                return 0;
            },

            getRentNowPrice() {
                const rentNowPrice = _.filter(this.product.pricing, (price) => price.label === 'Rent Now').pop();
                if (rentNowPrice !== undefined) {
                    return rentNowPrice.amount;
                }

                return 0;
            },

            displayPrice() {
                const categoryDisplayPriceId = this.forceGlobalPriceSetting ? this.globalPriceSetting : this.categoryDisplayPrice;
                if (categoryDisplayPriceId) {
                    const { pricing } = this.product;
                    const priceFromCategory = pricing.find(({id}) => id === categoryDisplayPriceId);
                    if (priceFromCategory) {
                        const isOnSale = !!parseFloat(priceFromCategory.sale_amount);
                        if(isOnSale) {
                          const originalAmount = priceFromCategory.amount;
                          const salePriceText = priceFromCategory.sale_formatted;
                          return `<h5 class="oldprice">\$${originalAmount}</h5><h5 class="newprice">${salePriceText}</h5>`
                        }

                        this.displayPriceId = priceFromCategory.id;
                        return `<h5>${ priceFromCategory.formatted }</h5>`;
                    }
                }
                if (!this.product.pricing.length) {
                    return '';
                }

                let price = this.product.pricing[0];
                if (this.product.display_price) {
                    price = this.product.display_price;
                }

                this.displayPriceId = price && price.id;
                if (typeof price.sale_amount !== 'undefined' && price.sale_amount > 0) {
                    return `<h5 class="oldprice">${ price.formatted }</h5><h5 class="newprice">${ price.sale_formatted }</h5>`;
                }

                return `<h5>${ price.formatted }</h5>`;
            },

            displayProductName() {
                return this.product.name;
            },

            getExpressItemClass() {
                return this.expressItemClass || 'express-delivery-default';
            }
        },
        computed: {
            savings() {
                const rentNowPrice = this.getRentNowPrice();
                if (rentNowPrice === 0){
                    return 0;
                }
                return (this.getWeeklyPrice() - this.getRentNowPrice()).toFixed(2);
            },
        }
    }
</script>
